import hasEmoji from '@/utils/hasEmoji'

export function useComment(name: Readonly<Ref<string | undefined>>) {
  const shouldShowDefaultAvatar = computed(() => hasEmoji(name.value || '') || !name.value)
  const firstLetter = computed(() => (name.value ? String.fromCodePoint(name.value.codePointAt(0) ?? 0) : ''))
  const { localeUpperCaseString: commenterFirstLetter } = useUpperCase(firstLetter)

  return {
    shouldShowDefaultAvatar,
    commenterFirstLetter,
  }
}
